(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7713],{

/***/ 958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92087);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34495);



var Highlight = function(param) {
    var children = param.children, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__/* .withModifiers */ .i)("highlight", variant, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default())),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().highlight__text),
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Highlight);


/***/ }),

/***/ 51036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ custom_Message; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-message.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconMessage = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 32,
  height: 37,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M31.125 36.5H.875a.497.497 0 0 1-.494-.497L.385 15.72a.494.494 0 1 1 .988 0L1.37 35.508H30.63l-.004-19.787a.494.494 0 1 1 .988 0l.004 20.281a.493.493 0 0 1-.493.497Z",
  fill: "#999"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M16.004 30.144h-.012a.484.484 0 0 1-.334-.131L.546 16.085a.496.496 0 0 1 .67-.728L16 28.981l14.783-13.624a.496.496 0 0 1 .7.029c.185.2.17.512-.029.699L16.341 30.01a.492.492 0 0 1-.337.133Z",
  fill: "#999"
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M31.124 36.498a.486.486 0 0 1-.291-.096l-12.245-9.005a.498.498 0 0 1-.106-.692.498.498 0 0 1 .692-.106l12.245 9.005c.22.163.266.47.106.692a.502.502 0 0 1-.4.203ZM.875 36.5a.494.494 0 0 1-.292-.895L12.829 26.6a.494.494 0 1 1 .586.799L1.17 36.404a.498.498 0 0 1-.295.096ZM25.712 21.198a.494.494 0 0 1-.494-.494V5.562H6.781v15.14a.494.494 0 1 1-.988 0V5.069c0-.273.22-.494.494-.494h19.425c.273 0 .494.221.494.494v15.635c0 .273-.22.495-.494.495Z",
  fill: "#999"
})), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
  d: "M11.885 5.562a.494.494 0 0 1-.348-.845L15.65.643a.494.494 0 1 1 .697.703l-4.114 4.073a.498.498 0 0 1-.348.143Z",
  fill: "#999"
})), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
  d: "M20.106 5.563a.492.492 0 0 1-.348-.143l-4.106-4.075a.495.495 0 0 1 .696-.702l4.106 4.075a.495.495 0 0 1-.348.845ZM.881 16.218a.494.494 0 0 1-.343-.848l5.408-5.265a.494.494 0 1 1 .689.709l-5.409 5.262a.496.496 0 0 1-.345.142ZM31.12 16.216a.49.49 0 0 1-.345-.141l-5.407-5.265a.496.496 0 0 1 .69-.71l5.406 5.266a.495.495 0 0 1-.343.85Z",
  fill: "#999"
})), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
  d: "M16 21.395a6.066 6.066 0 0 1-4.324-1.793 6.068 6.068 0 0 1-1.793-4.324c0-1.634.635-3.17 1.793-4.325A6.06 6.06 0 0 1 16 9.16c1.634 0 3.17.636 4.325 1.793a6.064 6.064 0 0 1 1.793 4.325c0 1.633-.635 3.169-1.793 4.324A6.08 6.08 0 0 1 16 21.395Zm0-11.247a5.136 5.136 0 0 0-5.129 5.13 5.136 5.136 0 0 0 5.13 5.13 5.136 5.136 0 0 0 5.129-5.13c0-2.83-2.302-5.13-5.13-5.13Z",
  fill: "#B18D3B"
})), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
  d: "M14.849 17.761a.478.478 0 0 1-.348-.146l-1.685-1.68a.496.496 0 0 1 .7-.7l1.334 1.336 3.633-3.634a.495.495 0 0 1 .7.7L15.2 17.618a.494.494 0 0 1-.351.143Z",
  fill: "#B18D3B"
})));

/* harmony default export */ var icon_message = (SvgIconMessage);
// EXTERNAL MODULE: ./providers/modalProvider.js
var modalProvider = __webpack_require__(51472);
// EXTERNAL MODULE: ./components/custom/Message/styles.module.scss
var styles_module = __webpack_require__(14234);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
;// CONCATENATED MODULE: ./components/custom/Message/index.js






var Message = function(param) {
    var title = param.title, subtitle = param.subtitle, button = param.button, _type = param.type, type = _type === void 0 ? "success" : _type;
    var handleCloseModal = (0,modalProvider/* useModalContext */.vR)().handleCloseModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,withModifiers/* withModifiers */.i)("message", [
            type
        ], (styles_module_default())),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_message, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (styles_module_default()).message__title,
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (styles_module_default()).message__subtitle,
                children: subtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                onClick: function() {
                    return handleCloseModal();
                },
                href: button.href && button.href,
                arrow: button === null || button === void 0 ? void 0 : button.arrow,
                children: button.label
            })
        ]
    });
};
/* harmony default export */ var custom_Message = (Message);


/***/ }),

/***/ 33528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25436);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34495);
/* harmony import */ var _elements_LazyImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20027);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41197);
/* harmony import */ var _helpers_getS3Url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27895);






var Staff = function(param) {
    var picture = param.picture, cloudflare_picture = param.cloudflare_picture, email = param.email, _variant = param.variant, variant = _variant === void 0 ? [] : _variant, width = param.width, height = param.height, first_name = param.first_name, last_name = param.last_name, job = param.job, subtitle = param.subtitle, _button = param.button, button = _button === void 0 ? true : _button;
    var isGeneral = variant.includes("general");
    var removeJob = variant.includes("remove-job");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_4__/* .withModifiers */ .i)("staff", variant, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default())),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().staff__image),
                style: {
                    width: width || 180,
                    height: height || 260
                },
                children: picture && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_LazyImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    alt: "Profile image-".concat(picture),
                    layout: "fill",
                    src: cloudflare_picture ? (0,_helpers_getS3Url__WEBPACK_IMPORTED_MODULE_3__/* .getS3Url */ .v)(cloudflare_picture, "640") : (0,_helpers_getS3Url__WEBPACK_IMPORTED_MODULE_3__/* .getS3Url */ .v)(picture)
                }, picture)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().staff__details),
                children: [
                    (first_name || last_name) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().staff__name),
                        children: [
                            first_name,
                            " ",
                            last_name
                        ]
                    }),
                    job && !removeJob && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_4__/* .withModifiers */ .i)("staff__position", [
                            isGeneral && "general"
                        ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default())),
                        children: job
                    }),
                    subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().staff__subtitle),
                        children: subtitle
                    }),
                    button && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
                        rel: "nofollow",
                        href: "mailto:".concat(email),
                        variant: [
                            "label",
                            "blue",
                            (button === null || button === void 0 ? void 0 : button.variant) && button.variant
                        ],
                        children: (button === null || button === void 0 ? void 0 : button.label) || "Email ".concat(first_name)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Staff);


/***/ }),

/***/ 20027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var LazyImage = function(_param) {
    var src = _param.src, index = _param.index, width = _param.width, height = _param.height, alt = _param.alt, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "index",
        "width",
        "height",
        "alt"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), blur = ref[0], setBlur = ref[1];
    var getSmallImageSrc = function(src) {
        // Ensure src is a string before calling replace
        if (typeof src === "string") {
            return src.replace(/\b(1980|3840|640|960|360)\b/g, "64");
        }
        return null;
    };
    var isLayout = props.layout === "fill";
    // Filter out srcSet and sizes from props as Next.js Image doesn't support them directly
    // eslint-disable-next-line no-unused-vars
    var srcSet = props.srcSet, sizes = props.sizes, imageProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "srcSet",
        "sizes"
    ]);
    // Only render if src is a valid string
    if (src && typeof src === "string") {
        var blurDataURL = getSmallImageSrc(src);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            width: !isLayout && (width || 590),
            height: !isLayout && (height || 393),
            src: src,
            style: {
                objectFit: "cover"
            },
            blurDataURL: blurDataURL,
            placeholder: blurDataURL ? "blur" : "empty",
            className: blur ? "img-blur" : "unblur",
            onLoadingComplete: function() {
                return setBlur(false);
            },
            alt: alt || "Property presentation image ".concat(index)
        }, imageProps));
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (LazyImage);


/***/ }),

/***/ 24447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6644);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34495);
/* harmony import */ var _LazyImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20027);
/* eslint-disable react/prop-types */ 









var CloudflareVideo = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9562).then(__webpack_require__.bind(__webpack_require__, 69562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69562)
            ];
        }
    }
});
var Section = function(_param) {
    var children = _param.children, className = _param.className, _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, bg = _param.bg, _video = _param.video, video = _video === void 0 ? false : _video, cloudflare = _param.cloudflare, _separator = _param.separator, separator = _separator === void 0 ? false : _separator, sectionRef = _param.sectionRef, _grayscale = _param.grayscale, grayscale = _grayscale === void 0 ? false : _grayscale, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "variant",
        "bg",
        "video",
        "cloudflare",
        "separator",
        "sectionRef",
        "grayscale"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        ref: sectionRef,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__/* .withModifiers */ .i)("section", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(variant).concat([
            separator && "has-separator",
            bg && "with-bg"
        ]), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default())), className)
    }, props), {
        children: [
            bg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                src: bg,
                priority: true,
                objectPosition: "center",
                objectFit: "cover",
                sizes: "(max-width: 360px) 960px, (max-width: 640px) 960px, (max-width: 1400px) 1400px, 1980px",
                alt: "section background image",
                layout: "fill"
            }),
            (cloudflare || video) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__/* .withModifiers */ .i)("section__video", [
                    grayscale && "grayscale"
                ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default())),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloudflareVideo, {
                        name: "Section presentation video",
                        autoplay: true,
                        loop: true,
                        muted: true,
                        src: cloudflare || video
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section__overlay)
                    })
                ]
            }),
            separator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section__separator)
            }),
            children
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Section);


/***/ }),

/***/ 27895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ getS3Url; }
/* harmony export */ });
/* harmony import */ var lodash_es_isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27771);
/* harmony import */ var lodash_es_isString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36378);
/* eslint-disable no-undef */ 

// URL cache to avoid redundant calculations
var urlCache = {};
// Detect mobile once and reuse
var isMobile = false;
var isMobileLandscape = false;
// Set up mobile detection only on client
if (true) {
    // Set this once at module level for initial render
    isMobile = window.innerWidth < 360;
    isMobileLandscape = window.innerWidth >= 360 && window.innerWidth < 640;
    // Update on resize with debouncing
    var resizeTimeout;
    window.addEventListener("resize", function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            var width = window.innerWidth;
            isMobile = width < 360;
            isMobileLandscape = width >= 360 && width < 640;
        }, 200);
    });
}
function getS3Url(url) {
    var variant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "public", video = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // Return early if no URL
    if (!url || !(0,lodash_es_isArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(url) && !(0,lodash_es_isString__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(url)) {
        return;
    }
    // For server-side rendering, use largest image
    var isServerSide = "object" === "undefined";
    // Use server defaults or client detection
    var effectiveIsMobile = isServerSide ? false : isMobile;
    var effectiveIsMobileLandscape = isServerSide ? false : isMobileLandscape;
    // Generate a cache key
    var cacheKey = "".concat(url, "-").concat(variant, "-").concat(video, "-").concat(effectiveIsMobile, "-").concat(effectiveIsMobileLandscape);
    // Return cached URL if available
    if (urlCache[cacheKey]) {
        return urlCache[cacheKey];
    }
    var result;
    // Determine which type of URL this is
    if (url.includes("images/") || url.includes("videos/")) {
        result = "https://assets.sxmsir.com/" + url.replaceAll(" ", "%20");
    } else if (video) {
        result = "https://customer-".concat("mwbbzmyggbfuda1b", ".cloudflarestream.com/").concat(url, "/manifest/video.m3u8");
    } else {
        // Determine the cloudflare variant to use
        var cloudflareVariant;
        // Server-side: Prioritize provided variant if it exists, otherwise use largest
        if (isServerSide) {
            cloudflareVariant = variant && variant !== "public" && variant !== "" ? variant // Use provided variant if it exists and is not 'public' or empty
             : "1980" // Otherwise use largest variant for server-side
            ;
        } else {
            // Client-side: Use existing responsive logic
            cloudflareVariant = effectiveIsMobile ? 360 : effectiveIsMobileLandscape ? 640 : variant === "public" || variant === "" || !variant ? 960 : variant;
        }
        result = "https://imagedelivery.net/".concat("356b0XxwgMp5GfAe77K8NQ", "/").concat(url, "/").concat(cloudflareVariant);
    }
    // Cache the result
    urlCache[cacheKey] = result;
    return result;
}


/***/ }),

/***/ 64150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64636);
/* harmony import */ var _elements_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(117);
/* harmony import */ var _elements_form_CustomField__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56375);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41197);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47154);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40670);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98077);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var _components_configs_axios__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92375);
/* harmony import */ var _providers_modalProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51472);
/* harmony import */ var _custom_Message__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51036);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_11__);















var ContactForm = function(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, _route = _param.route, route = _route === void 0 ? "email/send" : _route, disabled = _param.disabled, thankYou = _param.thankYou, translations = _param.translations, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_param, [
        "variant",
        "route",
        "disabled",
        "thankYou",
        "translations"
    ]);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_11__.useRouter)();
    var isSmallMobile = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__/* .useResponsive */ .F)().isSmallMobile;
    var formInitialValues = {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
        page: router.asPath
    };
    var ref = (0,_providers_modalProvider__WEBPACK_IMPORTED_MODULE_9__/* .useModalContext */ .vR)(), handleShowModal = ref.handleShowModal, setContent = ref.setContent, setVariant = ref.setVariant;
    var SignupSchema = yup__WEBPACK_IMPORTED_MODULE_6__/* .object */ .Ry().shape({
        firstName: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().max(25).matches(RegExp("^'?\\p{L}+(?:[' ]\\p{L}+)*'?$", "u"), translations.form.error.validName[router.locale]).required(translations.form.error.requiredFirstName[router.locale]),
        lastName: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().max(25).matches(RegExp("^'?\\p{L}+(?:[' ]\\p{L}+)*'?$", "u"), translations.form.error.validName[router.locale]).required(translations.form.error.requiredLastName[router.locale]),
        email: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().max(254).matches(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, translations.form.error.validEmail[router.locale]).email(translations.form.error.validEmail[router.locale]).required(translations.form.error.requiredEmail[router.locale]),
        phone: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().max(20)
    });
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""), phone = ref1[0], setPhone = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), submitted = ref2[0], setSubmitted = ref2[1];
    var handleSubmit = function(values, param) {
        var setSubmitting = param.setSubmitting, resetForm = param.resetForm;
        setSubmitting(true);
        _components_configs_axios__WEBPACK_IMPORTED_MODULE_8__/* ["default"].post */ .Z.post(route, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, values, props)).then(function() {
            _components_configs_axios__WEBPACK_IMPORTED_MODULE_8__/* ["default"].post */ .Z.post("active/pipe", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, values, props)).catch(function(err) {
                return console.error(err);
            });
            setSubmitted(true);
            setVariant([
                "contained",
                "xs"
            ]);
            setContent(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Message__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                title: translations.form.success.title[router.locale],
                subtitle: translations.form.success.subtitle[router.locale],
                button: {
                    label: translations.form.success.button[router.locale],
                    href: (thankYou === null || thankYou === void 0 ? void 0 : thankYou.url) || "/vacation-rentals",
                    arrow: false
                }
            }));
            handleShowModal();
            resetForm();
            setPhone("");
        }).catch(function(err) {
            return console.error(err);
        });
        setSubmitting(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
            validationSchema: SignupSchema,
            initialValues: formInitialValues,
            onSubmit: handleSubmit,
            children: function(param) {
                var errors = param.errors, touched = param.touched, values = param.values, setFieldValue = param.setFieldValue;
                var fieldVariant = variant.includes("dark") ? [
                    "full-width"
                ] : [
                    "gray",
                    "underline",
                    "full-width"
                ];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            variant: [
                                isSmallMobile ? "grid-1" : "grid-2",
                                "rows-xs"
                            ],
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_form_CustomField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    isActive: values.firstName,
                                    disabled: disabled,
                                    required: true,
                                    name: "firstName",
                                    placeholder: translations.form.fields.firstName[router.locale],
                                    maxLength: 20,
                                    onChange: function(e) {
                                        setFieldValue("firstName", e.target.value.replace(/[0-9]/g, ""));
                                    },
                                    variant: fieldVariant,
                                    error: errors.firstName && (touched === null || touched === void 0 ? void 0 : touched.firstName)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_form_CustomField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    disabled: disabled,
                                    required: true,
                                    maxLength: 20,
                                    isActive: values.lastName,
                                    name: "lastName",
                                    placeholder: translations.form.fields.lastName[router.locale],
                                    variant: fieldVariant,
                                    onChange: function(e) {
                                        setFieldValue("lastName", e.target.value.replace(/[0-9]/g, ""));
                                    },
                                    error: errors.lastName && touched.lastName
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_form_CustomField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    disabled: disabled,
                                    required: true,
                                    name: "email",
                                    type: "email",
                                    isActive: values.email,
                                    maxLength: 254,
                                    placeholder: translations.form.fields.email[router.locale],
                                    variant: fieldVariant,
                                    error: errors.email && touched.email,
                                    valid: values.email && !errors.email && touched.email
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_form_CustomField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    disabled: disabled,
                                    name: "phone",
                                    maxLength: 20,
                                    optional: true,
                                    isActive: values.phone,
                                    onChange: function(e) {
                                        setFieldValue("phone", e.target.value.replace(/[^0-9+()]/g, ""));
                                        setPhone(e.target.value.replace(/[^0-9+()]/g, ""));
                                    },
                                    value: phone,
                                    type: "tel",
                                    placeholder: translations.form.fields.phone[router.locale],
                                    variant: fieldVariant
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_form_CustomField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            disabled: disabled,
                            name: "message",
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().message),
                            optional: true,
                            type: "textarea",
                            as: "textarea",
                            rows: 9,
                            label: translations.form.fields.message[router.locale],
                            variant: [
                                "gray",
                                "full-width"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_4__["default"], {
                            disabled: errors.firstName || errors.lastName || errors.email || submitted || disabled,
                            variant: [
                                !variant.includes("dark") && "primary-blue",
                                "xl"
                            ],
                            children: translations.form.fields.submit[router.locale]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().terms),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                dangerouslySetInnerHTML: {
                                    __html: translations.form.agreement[router.locale]
                                }
                            })
                        })
                    ]
                });
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactForm);


/***/ }),

/***/ 92087:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"highlight":"styles_highlight__hfWCW","highlight__text":"styles_highlight__text__Rj3SA","highlight--offset-left":"styles_highlight--offset-left__lSHjR","highlight--accent":"styles_highlight--accent___xRbD","highlight--font-primary":"styles_highlight--font-primary__gTX3v"};

/***/ }),

/***/ 14234:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"message":"styles_message__IQwiF","message__title":"styles_message__title__GlV0y","message__subtitle":"styles_message__subtitle__BZWor","message--error":"styles_message--error__hmqU0"};

/***/ }),

/***/ 25436:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"staff":"styles_staff__8GMpd","staff__image":"styles_staff__image__YNYQR","staff__name":"styles_staff__name___4c2R","staff__details":"styles_staff__details__niCiI","staff__position":"styles_staff__position__p8vR5","staff__position--general":"styles_staff__position--general__5uOfO","staff__subtitle":"styles_staff__subtitle__3k9Zs","staff--inline":"styles_staff--inline__6Lj8P","staff--align-middle":"styles_staff--align-middle__b51PO","staff--image-full":"styles_staff--image-full__j6pAX","staff--columns":"styles_staff--columns__U0Min"};

/***/ }),

/***/ 6644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__yHGzn","section__image":"styles_section__image__3wu_0","section__separator":"styles_section__separator__jTwxZ","section__overlay":"styles_section__overlay__S4fzZ","section__video":"styles_section__video__aGMVE","section__video--grayscale":"styles_section__video--grayscale__cSkkv","section--separator-large":"styles_section--separator-large__e2xv7","section--has-separator":"styles_section--has-separator__9vXz9","section--separator-top":"styles_section--separator-top__EcwNQ","section--gray":"styles_section--gray__GL0Sw","section--white":"styles_section--white__NJa_K","section--contained":"styles_section--contained__Laf5M","section--center":"styles_section--center__LmG2q","section--primary":"styles_section--primary__GuN0k","section--darker":"styles_section--darker__uJmer","section--bg-body":"styles_section--bg-body__g_dZD","section--o-hidden":"styles_section--o-hidden__xJTM8","section--with-bg":"styles_section--with-bg__fgmbo","section--pt0":"styles_section--pt0__IoFne","section--full-height":"styles_section--full-height__xFIuY","section--bottom":"styles_section--bottom__hRh3f","section--p0":"styles_section--p0__CiUN0","section--pb0":"styles_section--pb0__OvCBe","section--p-xs":"styles_section--p-xs__AOSqe","section--p-xl":"styles_section--p-xl__9nhJz","section--z-7":"styles_section--z-7__RDdr0"};

/***/ }),

/***/ 47154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"terms":"styles_terms__qvg8t","message":"styles_message__AGXMm"};

/***/ })

}]);